// extracted by mini-css-extract-plugin
export default {"app":"App_app__WoFVZ","content":"App_content__8jHKJ"};